export const FileShield02Icon = ({
  className,
  pathClassName,
}: {
  className?: string;
  pathClassName?: string;
}) => (
  <svg
    width="17"
    height="20"
    viewBox="0 0 17 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M9.66668 9.16675H4.66668M6.33334 12.5001H4.66668M11.3333 5.83341H4.66668M14.6667 8.33342V5.66675C14.6667 4.26662 14.6667 3.56655 14.3942 3.03177C14.1545 2.56137 13.7721 2.17892 13.3017 1.93923C12.7669 1.66675 12.0668 1.66675 10.6667 1.66675H5.33334C3.93321 1.66675 3.23315 1.66675 2.69837 1.93923C2.22796 2.17892 1.84551 2.56137 1.60583 3.03177C1.33334 3.56655 1.33334 4.26662 1.33334 5.66675V14.3334C1.33334 15.7335 1.33334 16.4336 1.60583 16.9684C1.84551 17.4388 2.22796 17.8212 2.69837 18.0609C3.23315 18.3334 3.93321 18.3334 5.33334 18.3334H8.41668M13 17.5001C13 17.5001 15.5 16.3085 15.5 14.5211V12.4358L13.677 11.7844C13.239 11.6275 12.76 11.6275 12.322 11.7844L10.5 12.4358V14.5211C10.5 16.3085 13 17.5001 13 17.5001Z"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={pathClassName}
    />
  </svg>
);
